/**
 * Что показывает диалог библиотеки: форму нового опроса, загрузку, форму
 * правки или ничего, если опрос для правки не загрузился (ошибка запроса
 * или его уже нет). В последнем случае диалог сообщает об ошибке и
 * закрывается, а не висит пустым.
 */
export type PollDialogState = "create" | "loading" | "failed" | "edit";

export function pollDialogState(params: {
  pollId: string | null;
  loading: boolean;
  hasPoll: boolean;
}): PollDialogState {
  if (!params.pollId) return "create";
  if (params.hasPoll) return "edit";
  return params.loading ? "loading" : "failed";
}
